import { applyMiddleware, legacy_createStore as createStore, combineReducers } from "redux"
import globle from "./globle/reducer"
import thunk from "redux-thunk"
import { IGlobleState } from "./globle/types"

export interface IState {
  globle: IGlobleState
}

const reducer = combineReducers({
  globle
})

const store = createStore(reducer, applyMiddleware(thunk))

export default store